/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Clear_Event_TextInputs */

const en_shortcut_keys_desc_clear_event_text = /** @type {(inputs: Shortcut_Keys_Desc_Clear_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear the text of the selected Events`)
};

const fr_shortcut_keys_desc_clear_event_text = /** @type {(inputs: Shortcut_Keys_Desc_Clear_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer le texte des evenements selectionnes`)
};

const de_shortcut_keys_desc_clear_event_text = /** @type {(inputs: Shortcut_Keys_Desc_Clear_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den Text der ausgewählten Ereignisse löschen`)
};

const it_shortcut_keys_desc_clear_event_text = /** @type {(inputs: Shortcut_Keys_Desc_Clear_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella il testo degli eventi selezionati`)
};

const ru_shortcut_keys_desc_clear_event_text = /** @type {(inputs: Shortcut_Keys_Desc_Clear_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить текст выбранных событий`)
};

const es_shortcut_keys_desc_clear_event_text = /** @type {(inputs: Shortcut_Keys_Desc_Clear_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar el texto de los eventos seleccionados`)
};

const zh_cn2_shortcut_keys_desc_clear_event_text = /** @type {(inputs: Shortcut_Keys_Desc_Clear_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除所选事件的文本`)
};

const ja_shortcut_keys_desc_clear_event_text = /** @type {(inputs: Shortcut_Keys_Desc_Clear_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントのテキストをクリアします`)
};

const hi_shortcut_keys_desc_clear_event_text = /** @type {(inputs: Shortcut_Keys_Desc_Clear_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट्स का टेक्स्ट साफ़ करें`)
};

const pt_pt2_shortcut_keys_desc_clear_event_text = /** @type {(inputs: Shortcut_Keys_Desc_Clear_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar o texto dos eventos selecionados`)
};

/**
* | output |
* | --- |
* | "Clear the text of the selected Events" |
*
* @param {Shortcut_Keys_Desc_Clear_Event_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_clear_event_text = /** @type {((inputs?: Shortcut_Keys_Desc_Clear_Event_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Clear_Event_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_clear_event_text(inputs)
	if (locale === "de") return de_shortcut_keys_desc_clear_event_text(inputs)
	if (locale === "it") return it_shortcut_keys_desc_clear_event_text(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_clear_event_text(inputs)
	if (locale === "es") return es_shortcut_keys_desc_clear_event_text(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_clear_event_text(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_clear_event_text(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_clear_event_text(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_clear_event_text(inputs)
	return en_shortcut_keys_desc_clear_event_text(inputs)
});